/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DragonTribeGameModuleConfig} from "./DragonTribeGameModuleConfig";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {REWinFieldController} from "./keypad/REWinFieldController";

export class DragonTribe extends SlotGame {

    constructor() {
        super(DragonTribeGameModuleConfig.instance);
    }

    protected createWinFieldController():WinFieldController {
        return new REWinFieldController();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "X",
                    "X",
                    "L1",
                    "M4",
                    "M2",
                    "L4"
                ],
                [
                    "X",
                    "X",
                    "M2",
                    "L6",
                    "L6",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "L3",
                    "M5",
                    "L5",
                    "M3"
                ],
                [
                    "X",
                    "X",
                    "L4",
                    "L4",
                    "L3",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "M4",
                    "L1",
                    "M2",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "L5",
                    "L6",
                    "L4",
                    "L4"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "X",
                    "L1",
                    "M4",
                    "M2",
                    "L4"
                ],
                [
                    "X",
                    "X",
                    "M2",
                    "L6",
                    "L6",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "L3",
                    "M5",
                    "L5",
                    "M3"
                ],
                [
                    "X",
                    "X",
                    "L4",
                    "L4",
                    "L3",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "M4",
                    "L1",
                    "M2",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "L5",
                    "L6",
                    "L4",
                    "L4"
                ]
            ],
            "betWayWins": [],
            "totalBetLineWinnings": 0,
            "thisAvalancheWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 2,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "overlayWilds": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "gameSizeEnteringFreespin": [
                4,
                4,
                4,
                4,
                4,
                4
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "gameAreaSize": [
                4,
                4,
                4,
                4,
                4,
                4
            ],
            "totalNumberOfWays": 4096,
            "reelsAfterCollapse": [
                [
                    "X",
                    "X",
                    "L1",
                    "M4",
                    "M2",
                    "L4"
                ],
                [
                    "X",
                    "X",
                    "M2",
                    "L6",
                    "L6",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "L3",
                    "M5",
                    "L5",
                    "M3"
                ],
                [
                    "X",
                    "X",
                    "L4",
                    "L4",
                    "L3",
                    "L6"
                ],
                [
                    "X",
                    "X",
                    "M4",
                    "L1",
                    "M2",
                    "L5"
                ],
                [
                    "X",
                    "X",
                    "L5",
                    "L6",
                    "L4",
                    "L4"
                ]
            ],
            "allWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfScatters": 0,
            "numberOfWaysWon": 0,
            "wildMultipliers": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "wildOnReel": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "avalancheCountThisSpinBefore": 0,
            "avalancheCountThisSpinAfter": 0,
            "avalancheCountThisRoundBefore": 0,
            "avalancheCountThisRoundAfter": 0,
            "newSymbols": [],
            "mysterySymbolOnReel": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "mysterySymbolSize": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "mysterySymbolRevealed": "",
            "mysterySymbolPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "xWaysSymbolMayGiveWin": false,
            "totalAvalancheRoundWinnings": 0,
            "numberOfScattersBefore": 0,
            "freespinExtreme": false,
            "playerFSSelection": -1,
            "xWaysSymbolMayGiveWinPositions": [
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 80
                }
            ],
            "wasFeatureBuy": false
        };
    }

    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (DragonTribe.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }
}